<ion-header class="ion-no-border page menu-page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div class="leada-powered">POWERED BY LEADA AG</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="goBack()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

</ion-header>

<ion-content class="ion-padding page" no-bounce>
  <div #line class="line" [style.top]="lineY"></div>
  <ion-list lines="none" class="menu">
    <ion-item button disabled><div translate>MENU.PERSONAL.NAME</div></ion-item>
    <ion-item button (click)="showGoalsPage()" *ngIf="showMenuEntry('MENU.PERSONAL.GOALS')"><div translate>{{episodesOnly ? 'GOALS.EPISODES.MENU' : 'MENU.PERSONAL.GOALS'}}</div></ion-item>
    <ion-item button (click)="showMonitoringPage()" *ngIf="showMenuEntry('MENU.PERSONAL.MONITORING')"><div translate>MENU.PERSONAL.MONITORING</div></ion-item> 
    <ion-item button *ngIf="showMenuEntry('MENU.PERSONAL.AWARDS') && (showMenuEntry('MENU.PERSONAL.BADGES') || showMenuEntry('MENU.PERSONAL.CERTIFICATES'))"><div translate>MENU.PERSONAL.AWARDS</div></ion-item>
    <ion-item button class="second-level" (click)="showBadgesPage()" *ngIf="showMenuEntry('MENU.PERSONAL.BADGES')"><div translate>MENU.PERSONAL.BADGES<ion-badge *ngIf="newBadgeCount" button-end class="badge">{{ newBadgeCount }}</ion-badge></div></ion-item> 
    <ion-item button class="second-level" (click)="showContentCerfificates()" *ngIf="showMenuEntry('MENU.PERSONAL.CERTIFICATES')"><div translate>MENU.PERSONAL.CERTIFICATES</div></ion-item> 
</ion-list>

</ion-content>

<ion-footer class="page">
  <ion-button fill="clear" shape="round" (click)="showSettings()" class="settings"><ion-icon slot="icon-only"></ion-icon></ion-button>
  <ion-button fill="clear" shape="round" (click)="showSearch()" class="search"><ion-icon slot="icon-only"></ion-icon></ion-button>
</ion-footer>

